import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ContentWizardStep = ({ 
  currentStep, 
  totalSteps, 
  title, 
  subtitle,
  children,
  onBack,
  onNext,
  nextLabel = "Próximo",
  nextDisabled = false,
  showBack = true
}) => {
  return (
    <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-gray-100 max-w-4xl w-full mx-auto animate-fadeIn">
      {/* Progress Indicator */}
      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm font-semibold text-gray-500">
            Passo {currentStep} de {totalSteps}
          </span>
          <span className="text-sm font-semibold text-amber-600">
            {Math.round((currentStep / totalSteps) * 100)}%
          </span>
        </div>
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-amber-400 to-orange-500 transition-all duration-500 ease-out"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          />
        </div>
      </div>

      {/* Header */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          {title}
        </h2>
        {subtitle && (
          <p className="text-lg text-gray-600">
            {subtitle}
          </p>
        )}
      </div>

      {/* Content */}
      <div className="mb-8">
        {children}
      </div>

      {/* Navigation Buttons */}
      <div className="flex items-center justify-between pt-6 border-t border-gray-200">
        {showBack ? (
          <button
            onClick={onBack}
            className="inline-flex items-center px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-all gap-2"
          >
            <ChevronLeft className="w-5 h-5" />
            Voltar
          </button>
        ) : (
          <div />
        )}

        <button
          onClick={onNext}
          disabled={nextDisabled}
          className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-amber-400 to-orange-500 text-white rounded-xl font-bold hover:from-amber-500 hover:to-orange-600 transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-lg gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
          {nextLabel}
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ContentWizardStep;